import { render } from "./CommentFilterItem.vue?vue&type=template&id=13d7ae7e"
import script from "./CommentFilterItem.vue?vue&type=script&lang=js"
export * from "./CommentFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__